import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

//------------------------------------------------------------------------------
//                  Получение монет по кастомному тегу (custom-tag-coins)
//------------------------------------------------------------------------------
export async function getCoinsByCustomTag(tagName) {
  const url = `${backendUrl}/api/screener/signal-filter/custom-tag-coins/?name=${encodeURIComponent(tagName)}`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);

    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении custom-tag монет: HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка при получении монет по custom tag:', error);
    throw error;
  }
}
